import { FC, useMemo } from "react";

import {
  formatPrice,
  isNullOrEmptySpace,
  NO_VALUE_DISPLAY,
} from "@ryde/shared";

import { FramerTooltip } from "../../common";
import { useDecorateWithMark } from "../../utils";
import { IRenderColumnTemplate } from "./_core";

export const CurrencyCellTemplate: FC<IRenderColumnTemplate> = ({
  id,
  value,
  name,
  formFieldTypeId,
}) => {
  const { decorateValue } = useDecorateWithMark();

  const displayValue = useMemo(() => {
    const formattedValue = formatPrice({ value });
    return decorateValue(formattedValue);
  }, [value, decorateValue]);

  const tooltipContent = useMemo(() => {
    return formatPrice({ value });
  }, [value]);

  return (
    <div
      className="cell_simple"
      data-e2e-id={`${name}_fieldid_${formFieldTypeId}`}
      data-e2e-value={value}
      data-e2e-template="currency-cell"
      data-e2e-custom-field-id={id}
    >
      <FramerTooltip content={tooltipContent} rtlStrippedBottomLeftPlacement>
        <span>
          {!isNullOrEmptySpace(value) ? displayValue : NO_VALUE_DISPLAY}
        </span>
      </FramerTooltip>
    </div>
  );
};
